import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

export function useSessionUserId(): string | null {
  const [uid, setUid] = useState<string | null>(null);
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      setUid(data.session?.user.id ?? null);
    });
    const { data: sub } = supabase.auth.onAuthStateChange((_evt, session) => {
      setUid(session?.user.id ?? null);
    });
    return () => sub.subscription.unsubscribe();
  }, []);
  return uid;
}

const COOKIE_NAME = "bz_vid";
const ONE_YEAR = 60 * 60 * 24 * 365;

function readCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name: string, value: string) {
  if (typeof document === "undefined") return;
  document.cookie = `${name}=${encodeURIComponent(value)};path=/;max-age=${ONE_YEAR};SameSite=Lax`;
}

function genId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID().replace(/-/g, "");
  }
  return Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function useVisitorId(): string | null {
  const [vid, setVid] = useState<string | null>(null);
  useEffect(() => {
    let v = readCookie(COOKIE_NAME);
    if (!v) {
      v = genId();
      writeCookie(COOKIE_NAME, v);
    }
    setVid(v);
  }, []);
  return vid;
}
